import { render } from "./SqueezePage.vue?vue&type=template&id=58e93553&scoped=true"
import script from "./SqueezePage.vue?vue&type=script&lang=js"
export * from "./SqueezePage.vue?vue&type=script&lang=js"

import "./SqueezePage.vue?vue&type=style&index=0&id=58e93553&scoped=true&lang=css"

import exportComponent from "D:\\projects\\RED MENACE\\redmenacegames.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e93553"]])

export default __exports__